import { matchAccountConfigThroughHostname } from '@/widgets/Wizard/modules/accounts';
import accounts from '@/widgets/Wizard/accounts';

export function overrideTranslations(
    translations: { [key: string]: any },
    overriddenTranslations: { [key: string]: any },
): typeof translations {
    const account = matchAccountConfigThroughHostname(window.location.hostname, accounts);

    if (!account) {
        return translations;
    }

    if (!overriddenTranslations[account.code]) {
        return translations;
    }

    for (const locale in translations) {
        const messages = translations[locale];
        const overridden = overriddenTranslations[account.code][locale];

        if (!overridden) {
            continue;
        }

        translations[locale] = combineOverriddenKeys(messages, overridden);
    }

    return translations;
}

function combineOverriddenKeys(translations: any, overridden: any): any {
    for (const key in overridden) {
        if (typeof overridden[key] === 'object') {
            if (!translations[key] && overridden[key]) {
                translations[key] = {};
            }

            translations[key] = combineOverriddenKeys(translations[key], overridden[key]);
            continue;
        }

        if (!translations || !overridden[key]) {
            continue;
        }

        translations[key] = overridden[key];
    }

    return translations;
}
